module.exports = __webpack_public_path__ + "img/tablet_logo.c540f39f.png";